// extracted by mini-css-extract-plugin
export default {"whatsappButton":"FloatingWhatsApp_whatsappButton__dyVBN"};